import { v4 as uuidv4 } from 'uuid';

const setItem = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

const getItem = (key: string) => {
  let res = localStorage.getItem(key);
  if (res) {
    try {
      return JSON.parse(res);
    } catch {
      return res;
    }
  }
  return null;
};

const createUserSession = () => {
  const now = new Date().getTime();
  const sessionId = uuidv4();
  const session = {
    start: now,
    sessionId,
  };

  setItem('session', JSON.stringify(session));
  return session;
};

export  { setItem, getItem, createUserSession };
